<template>
  <transition
    name="router-anim"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutLeft"
  >
    <div class="kviz">
      <Progress v-show="$store.state.currentStep <= $store.state.maxStep-1" />
      <Kform />
    </div>
  </transition>
</template>
<script>
import Progress from '@/components/Progress.vue'
import Kform from '@/components/Kform.vue'

export default {
  name: 'home',
  components: {
    Progress,
    Kform
  },
  methods: {

  },
  mounted () {

  }
}
</script>
